import React, { useEffect } from "react";
import { Grid, Paper, Typography, Container } from "@material-ui/core";
import { Link } from "gatsby";
import AnswerItem from "./answer";
import { useAnalyticsEvents } from "../analytics/events.home";
// import { AnswerItem } from "./answer";

const QuestionItem = ({ item, answers, lang }) => {

  const { viewQuestionEvent } = useAnalyticsEvents()

  useEffect(() => {
    viewQuestionEvent(lang, item?.prismicId, item?.data?.title?.text)
  }, [item, lang])

  return (
    <Paper style={{ padding: "12px 0", borderBottomLeftRadius: "0", borderBottomRightRadius: "0" }}>
      <Grid>
        <Grid item>
          <Container>
            <Typography variant="h5" style={{ fontWeight: "bold" }} >
              {item?.data?.title?.text}
            </Typography>
          </Container>
        </Grid>
        <Grid item container>
          {answers && answers.map((answer) => {
            return <AnswerItem item={answer} key={answer?.prismicId} />;
          })}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default QuestionItem